import 'twin.macro';
import 'styled-components/macro';

import { SVGProps } from 'react';

import { ReactComponent as CheckIcon } from 'component-lib/atoms/icon/CheckIcon.svg';

export const SelectIndicator = (props: SVGProps<SVGSVGElement>) => <CheckIcon tw="text-secondary" {...props} />;
